import {
  Eye, Sparkles, Activity, ShieldAlert, Zap, Scissors, Droplets, Stethoscope,
  CalendarCheck, UserRound, Microscope, ClipboardCheck,
} from "lucide-react";
import content from "@/data/content.json";

export const ICONS = { Eye, Sparkles, Activity, ShieldAlert, Zap, Scissors, Droplets, Stethoscope, CalendarCheck, UserRound, Microscope, ClipboardCheck };

const asset = (path) => `${process.env.PUBLIC_URL || ""}${path}`;
export const CONTACT = content.contact;
export const EYE = content.eyeServices.map((service) => ({ ...service, image: asset(service.image) }));
export const SURGERY = content.surgeryServices.map((service) => ({ ...service, image: asset(service.image) }));
export const ALL_SERVICES = [...EYE, ...SURGERY];
export const STEPS = content.steps;
export const TESTIMONIALS = content.testimonials.map((story) => ({ ...story, photo: asset(story.photo) }));
export const DOCTORS = content.doctors.map((doctor) => ({ ...doctor, photo: asset(doctor.photo) }));

export const findService = (slug) => ALL_SERVICES.find((s) => s.slug === slug);
export const doctorFor = (dept) => DOCTORS.find((d) => d.dept === dept);

export const IMG = {
  logo: asset("/img/medicity-hospital-logo.png"),
  mark: asset("/img/medicity-hospital-icon.png"),
  reception: asset("/img/hospital-reception.jpg"),
  inauguration: asset("/img/eye-care-inauguration.jpg"),
  exam: asset("/img/eye-examination.jpg"),
  building: asset("/img/hospital-building.jpg"),
  pharmacy: asset("/img/hospital-optical-pharmacy.jpg"),
  surgeryOT: asset("/img/laparoscopic-surgery.jpg"),
  surgeryTeam: asset("/img/gallbladder-stone.jpg"),
};

export const THEME = {
  eye: {
    key: "eye", menuEn: "Eye Care", path: "/eye-care", labelHi: "नेत्र सेवाएँ", labelEn: "Eye Care",
    deptHi: "नेत्र रोग विभाग", deptEn: "Department of Ophthalmology",
    text: "text-maroon", bg: "bg-maroon", tint: "bg-maroon-tint", soft: "bg-maroon-soft", border: "border-maroon",
    btn: "btn-maroon", ring: "ring-maroon/20", hex: "#7A1538",
    image: IMG.inauguration,
    heroHi: "आँखों की रोशनी, विशेषज्ञ हाथों में",
    heroEn: "Advanced eye care & stitchless phaco cataract surgery in Ballia.",
  },
  surgery: {
    key: "surgery", menuEn: "Surgery", path: "/surgery", labelHi: "सर्जरी", labelEn: "General & Laparoscopic Surgery",
    deptHi: "सर्जरी विभाग", deptEn: "General & Laparoscopic Surgery",
    text: "text-surg", bg: "bg-surg", tint: "bg-surg-tint", soft: "bg-surg-soft", border: "border-surg",
    btn: "btn-teal", ring: "ring-surg/20", hex: "#0F766E",
    image: IMG.surgeryOT,
    heroHi: "छोटा चीरा, कम दर्द — दूरबीन से ऑपरेशन",
    heroEn: "Hernia, gallbladder stone, appendix, piles & more — keyhole surgery with faster recovery.",
  },
};

export const servicesOf = (dept) => (dept === "surgery" ? SURGERY : EYE);

export const TIME_PREFS = [
  "जल्द से जल्द / As soon as possible",
  "आज / Today",
  "कल / Tomorrow",
  "इस सप्ताह / This week",
  "बृहस्पतिवार — नि:शुल्क नेत्र जाँच / Thursday free eye check-up",
];

